import type { CSSProperties } from "react";

/** 观点 Feed 页：整体布局 */
export interface ViewpointFeedLayoutConfig {
  /**
   * 页面内容距顶部的距离（px，不含 safe-area；safe-area 会叠加在 paddingTop 上）。
   * 用于微调与空间顶栏 / 状态栏的视觉间距。
   */
  offsetTop: number;
  /** 内容区左右内边距（px） */
  paddingX: number;
  /** 内容区底部内边距（px，不含 tab-bar；tab-bar 由外层 shell 处理） */
  paddingBottom: number;
}

/** 观点 Feed 页：每条观点右上角分类标签 */
export interface ViewpointFeedCategoryTagConfig {
  /** 圆角（px） */
  borderRadius: number;
  /** 背景色 */
  background: string;
  /** 文字颜色 */
  color: string;
  /** 字号（px） */
  fontSize: number;
  /** 水平内边距（px） */
  paddingX: number;
  /** 垂直内边距（px） */
  paddingY: number;
}

export const VIEWPOINT_FEED_LAYOUT = {
  offsetTop: 8,
  paddingX: 16,
  paddingBottom: 16,
} as const satisfies ViewpointFeedLayoutConfig;

export const VIEWPOINT_FEED_CATEGORY_TAG = {
  borderRadius: 5,
  background: "rgba(255, 192, 203, 0.45)",
  color: "#000000",
  fontSize: 12,
  paddingX: 8,
  paddingY: 2,
} as const satisfies ViewpointFeedCategoryTagConfig;

/** 观点 Feed 页布局 CSS 变量（注入到 `.lf-vp-feed--h5`） */
export function viewpointFeedLayoutCssVars(): CSSProperties {
  const { offsetTop, paddingX, paddingBottom } = VIEWPOINT_FEED_LAYOUT;
  const tag = VIEWPOINT_FEED_CATEGORY_TAG;
  return {
    ["--lf-vp-feed-offset-top" as string]: `${offsetTop}px`,
    ["--lf-vp-feed-pad-x" as string]: `${paddingX}px`,
    ["--lf-vp-feed-pad-bottom" as string]: `${paddingBottom}px`,
    ["--lf-vp-category-tag-radius" as string]: `${tag.borderRadius}px`,
    ["--lf-vp-category-tag-bg" as string]: tag.background,
    ["--lf-vp-category-tag-color" as string]: tag.color,
    ["--lf-vp-category-tag-font-size" as string]: `${tag.fontSize}px`,
    ["--lf-vp-category-tag-pad-x" as string]: `${tag.paddingX}px`,
    ["--lf-vp-category-tag-pad-y" as string]: `${tag.paddingY}px`,
  };
}
